export { ArrowDownNarrow as default } from './ArrowDownNarrow';
